import { Link } from "react-router-dom";

export default function TermsOfService() {
  return (
    <div className="min-h-screen bg-zinc-950 text-zinc-200 p-6 md:p-10">
      <div className="max-w-3xl mx-auto" data-testid="terms-of-service-page">
        <Link to="/" className="text-amber-400 hover:text-amber-300 text-sm uppercase tracking-widest">← Retour</Link>
        <h1 className="text-4xl font-bold text-amber-400 mt-6 mb-2">Conditions d'utilisation</h1>
        <p className="text-xs text-zinc-500 uppercase tracking-widest mb-8">Dernière mise à jour : 27 mai 2026</p>

        <section className="space-y-6 text-sm leading-relaxed">
          <div>
            <h2 className="text-xl font-bold text-zinc-100 mb-2">1. Identité du service</h2>
            <p>
              Le service DOJOVA — Kaizen System (« le Service ») est exploité par <strong>Impact Kick-boxing/Jiu-jitsu inc.</strong>,
              opérant l'Institut Impact Élite Martial, dont le siège social est situé à Val-d'Or, Québec, Canada.
            </p>
            <p className="mt-2">Contact : <a href="mailto:ralph646@hotmail.com" className="text-amber-400 hover:underline">ralph646@hotmail.com</a> · (819) 527-9446</p>
          </div>

          <div>
            <h2 className="text-xl font-bold text-zinc-100 mb-2">2. Acceptation</h2>
            <p>
              En accédant au Service ou en utilisant nos APIs (Kaizen Manager, Mon Assistant Pro, intégrations
              TikTok / Meta / Stripe / Gmail), vous acceptez ces Conditions d'utilisation. Si vous n'acceptez pas,
              n'utilisez pas le Service.
            </p>
          </div>

          <div>
            <h2 className="text-xl font-bold text-zinc-100 mb-2">3. Description du Service</h2>
            <p>
              Kaizen est une plateforme de gestion de dojo et de réseau de coachs comprenant : gestion des membres,
              comptabilité, planification de cours, boutique en ligne, intégrations marketing (Facebook, Instagram,
              TikTok), facturation Stripe, communications automatisées et carnets de progression d'élèves.
            </p>
          </div>

          <div>
            <h2 className="text-xl font-bold text-zinc-100 mb-2">4. Comptes utilisateur</h2>
            <p>
              Vous êtes responsable de la confidentialité de votre mot de passe et de toutes les activités effectuées
              sous votre compte. Notifiez-nous immédiatement de tout usage non autorisé.
            </p>
          </div>

          <div>
            <h2 className="text-xl font-bold text-zinc-100 mb-2">5. Intégrations tierces</h2>
            <p>
              Le Service s'intègre à des plateformes tierces (TikTok, Meta/Facebook/Instagram, Stripe, Google/Gmail,
              ElevenLabs, HeyGen, Twilio, Printful). Vous reconnaissez que l'usage de ces intégrations est également
              régi par les conditions de service de chaque plateforme tierce.
            </p>
            <p className="mt-2">
              Pour TikTok spécifiquement : nous demandons les scopes <code className="text-amber-300">user.info.basic</code>,
              <code className="text-amber-300"> video.upload</code> et <code className="text-amber-300">video.publish</code>
              uniquement pour permettre la publication automatisée de contenus marketing depuis votre compte autorisé.
              Vous gardez le contrôle complet et pouvez révoquer l'accès à tout moment depuis votre compte TikTok.
            </p>
          </div>

          <div>
            <h2 className="text-xl font-bold text-zinc-100 mb-2">6. Utilisation acceptable</h2>
            <p>Vous vous engagez à ne pas :</p>
            <ul className="list-disc list-inside space-y-1 mt-2 ml-2">
              <li>Utiliser le Service à des fins illégales ou frauduleuses</li>
              <li>Tenter d'accéder à des comptes d'autres utilisateurs</li>
              <li>Publier du contenu offensant, diffamatoire ou enfreignant des droits d'auteur</li>
              <li>Envoyer du spam ou des communications non sollicitées via les outils du Service</li>
            </ul>
          </div>

          <div>
            <h2 className="text-xl font-bold text-zinc-100 mb-2">7. Propriété intellectuelle</h2>
            <p>
              Le code, le design, les marques DOJOVA et Kaizen System et tout le contenu du Service restent la propriété
              d'Impact Kick-boxing/Jiu-jitsu inc. Vous conservez la propriété du contenu que vous publiez via le Service.
            </p>
          </div>

          <div>
            <h2 className="text-xl font-bold text-zinc-100 mb-2">8. Paiements (Stripe)</h2>
            <p>
              Les paiements sont traités par Stripe Inc. Nous ne stockons jamais vos données de carte. Voir la
              <a href="https://stripe.com/legal" target="_blank" rel="noopener noreferrer" className="text-amber-400 hover:underline ml-1">politique Stripe</a>.
            </p>
          </div>

          <div>
            <h2 className="text-xl font-bold text-zinc-100 mb-2">9. Limitation de responsabilité</h2>
            <p>
              Le Service est fourni « tel quel ». Nous ne garantissons pas qu'il sera ininterrompu ou exempt d'erreurs.
              Notre responsabilité maximale est limitée au montant payé pour le Service durant les 12 derniers mois.
            </p>
          </div>

          <div>
            <h2 className="text-xl font-bold text-zinc-100 mb-2">10. Suppression de compte</h2>
            <p>
              Vous pouvez demander la suppression de votre compte et de vos données à tout moment via la page
              <Link to="/data-deletion" className="text-amber-400 hover:underline ml-1">Suppression des données</Link>.
            </p>
          </div>

          <div>
            <h2 className="text-xl font-bold text-zinc-100 mb-2">11. Modifications</h2>
            <p>
              Nous nous réservons le droit de modifier ces Conditions à tout moment. Les changements significatifs
              seront notifiés par courriel ou via le Service au moins 30 jours avant leur entrée en vigueur.
            </p>
          </div>

          <div>
            <h2 className="text-xl font-bold text-zinc-100 mb-2">12. Loi applicable</h2>
            <p>
              Ces Conditions sont régies par les lois de la province de Québec et les lois fédérales du Canada
              applicables. Tout litige sera soumis aux tribunaux compétents de Val-d'Or, Québec.
            </p>
          </div>

          <div className="pt-4 border-t border-zinc-800 mt-8">
            <Link to="/privacy-policy" className="text-amber-400 hover:underline text-sm">
              → Voir notre Politique de confidentialité
            </Link>
          </div>
        </section>
      </div>
    </div>
  );
}
